<main class="container py-4">
    <app-nav-header
        (back)="onBack()"
        pageTitle="About PolicyStreet"
        pageTitleCss="text-black"
        routeTo="aboutps"></app-nav-header>
    <div class="py-4">
        <img alt="ps" ngSrc="/assets/images/celcomdigi-ps.png" class="borders-round" height="441" width="784"
            priority />
    </div>

    <p class="text-gray-500">PolicyStreet, a leading insurtech company, is licensed as a Financial Adviser and
        an Islamic Financial Adviser by Bank Negara Malaysia.</p>

    <p class="text-gray-500">They provide a range of innovative insurance solutions tailored to both consumers
        and businesses — from car insurance and parcel protection to embedded coverage for gig workers and employee
        benefits.</p>

    <p class="text-gray-500">PolicyStreet’s mission is to make insurance Purposeful and Simple for everyone.</p>
</main>